/* Tualis tema — minimalus JS. Viskas veikia ir be jo (progresyvus papildymas). */
(function () {
  'use strict';

  /* Mobilus meniu */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById('mobile-nav');
    if (!nav) return;
    var open = nav.getAttribute('data-open') === 'true';
    nav.setAttribute('data-open', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* Prekės galerija */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.getAttribute('data-full');
    main.srcset = thumb.getAttribute('data-srcset') || '';
    main.alt = thumb.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* Kiekio laukelis */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    value += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    input.value = Math.max(min, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Krepšelio kiekio keitimas puslapyje — automatinis formos siuntimas */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty]')) return;
    var form = e.target.closest('form');
    if (form) form.submit();
  });

  /* Varianto pasirinkimas: atnaujina paslėptą id lauką ir kainą */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    form.addEventListener('change', function () {
      var chosen = Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]:checked'),
        function (i) { return i.value; }
      );
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      form.querySelector('[name="id"]').value = match.id;
      var price = document.querySelector('[data-price-now]');
      if (price && match.price_formatted) price.innerHTML = match.price_formatted;
      var button = form.querySelector('[data-add-button]');
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? button.getAttribute('data-text-add')
          : button.getAttribute('data-text-sold');
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    });
  });
})();
